import "@fontsource/lato/latin-400.css";
import "@fontsource/lato/latin-700.css";
import "@fontsource/lato/latin-900.css";
import "@fontsource/manrope/latin-400.css";
import "@fontsource/manrope/latin-500.css";
import "@fontsource/manrope/latin-600.css";
import "@fontsource/manrope/latin-700.css";
import "@fontsource/manrope/latin-800.css";
import "@fontsource/montserrat/latin-600.css";
import "@fontsource/montserrat/latin-700.css";
import "@fontsource/montserrat/latin-900.css";
import "./estilos/global.css";
import { capturarAtribuicao, evento, iniciarTelemetria } from "./telemetria.js";

// O HTML, o conteudo, os links e o SEO nao dependem deste arquivo. Ele cuida
// somente da interacao progressiva do simulador e da medicao da landing.
iniciarTelemetria();
const atribuicao = capturarAtribuicao();
evento("landing_visualizada", {
  origem: atribuicao?.origem ?? "direto",
  midia: atribuicao?.midia ?? "desconhecida",
  pagina: window.location.pathname,
});

Array.from(document.querySelectorAll<HTMLAnchorElement>("a[href]"))
  .filter((link) => {
    try { return new URL(link.href, window.location.href).pathname === "/painel"; }
    catch { return false; }
  })
  .forEach((link, indice) => link.addEventListener("click", () => {
    evento("cta_landing_clicado", {
      posicao_cta: indice + 1,
      cta_id: link.dataset.ctaId ?? `link_painel_${indice + 1}`,
      rotulo_cta: link.textContent?.trim().slice(0, 80) ?? "",
    });
  }));

// Shared progressive enhancement: static HTML stays readable without JavaScript.
import { iniciarInteracoesLanding } from "./telas/landing-interacoes.js";
const landing = document.querySelector<HTMLElement>("main.lp");
import { iniciarPrecosLanding } from "./telas/precos-landing.js";
if (landing) {
  iniciarInteracoesLanding(landing);
  iniciarPrecosLanding(landing, () => evento("simulador_preco_usado"));
}
